






import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {Storage} from 'aws-amplify';

@Component
export default class S3Video extends Vue {
  private src: any = '';
  private lazySrc: any = '';

  @Prop({type: String, default: ''}) private itemKey!: string;
  @Prop({type: Boolean, default: false}) private autoplay!: string;
  @Prop({type: String, default: 'public'}) private level!: string;

  private created() {
    return this.init(this.itemKey);
  }

  private async init(itemKey) {
    this.src = await Storage.get(itemKey, {level: this.level, expires: 60 * 60 * 24 * 2});
  }


  private error() {
    this.src = './img/loader.gif';

    setTimeout(() => {
      this.init(this.itemKey);
    }, 5000);
  }

  @Watch('itemKey')
  private reloadItem() {
    this.init(this.itemKey);
  }

  private load() {
    // console.log('load');
  }
}
